(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8159],{

/***/ 98159:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(10434));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(70215));

var _react = _interopRequireDefault(__webpack_require__(67294));

const IconBattery = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.112 13.108l-.024-.09a.625.625 0 00-.325-.383l-4.88-2.365c.346-1.1.683-2.197 1.015-3.286l.037-.127c.02-.062.037-.12.058-.18l1.396-4.556a.612.612 0 00-.045-.431.747.747 0 00-.275-.316l-.029-.017a.634.634 0 00-.76.124l-1.889 2.028h-.004a1.431 1.431 0 00-.973-.377h-1.421v-.94c0-.658-.526-1.192-1.171-1.192H8.05c-.65 0-1.175.534-1.175 1.191v.94H5.454C4.653 3.132 4 3.786 4 4.59v13.126c0 .805.653 1.458 1.454 1.458h5.138l-1.22 3.996a.625.625 0 00.062.464.74.74 0 00.332.313.649.649 0 00.723-.14l9.43-10.145.037-.033a.638.638 0 00.156-.521zM5.45 17.913a.207.207 0 01-.201-.201V4.557l.012-.037a.208.208 0 01.193-.136h2.05a.631.631 0 00.628-.628V2.253h2.604v1.503c0 .345.283.628.628.628h2.05c.045 0 .086.017.119.045l-6.707 7.213a.608.608 0 00-.169.418.622.622 0 00.35.567l1.425.707.024.008a91.325 91.325 0 003.442 1.614c-.164.526-.329 1.052-.489 1.577l-.427 1.376H5.45v.004z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconBattery, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports["default"] = _default;

/***/ }),

/***/ 10434:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 70215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(7071);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7071:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

}]);